import State from 'interfaces/state/State';

export const userName$ = (state: State): string => state.signUp.userName;
export const email$ = (state: State): string => state.signUp.email;
export const isError$ = (state: State): boolean => state.signUp.isError;
export const isLoading$ = (state: State): boolean => state.signUp.isLoading;
export const isRedirectToLogin$ = (state: State): boolean => state.signUp.isRedirectToLogIn;
